var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"field__error"},[_vm._v(_vm._s(_vm.$t('Checkout#Payment#Error Booking failed, session has expired. Please return and try again.')))])
}
var staticRenderFns = []

export { render, staticRenderFns }